import { FC } from "react";
import i18next from "i18next";
import { useNavigate } from "react-router-dom";
import { CoverImage } from "@/components";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import { Badge, Button, Flex } from "@radix-ui/themes";
import { Zones } from "@/models/database/zones/Zones.model";

export const OverviewArchive: FC<{
  headline: string;
  linkToBtnText?: string;
  linkToBtnLink?: string;
  subtitle: string;
  filterButtons?: any[];
  selectedFilter?: string;
  setSelectedFilter?: any;
  isOldV?: boolean;
  children?: any;
  disableBadges: boolean | undefined;
  background: string;
  setChallengeTitle?: any;
  zone?: Zones;
}> = ({
  filterButtons,
  selectedFilter,
  setSelectedFilter,
  headline,
  linkToBtnLink,
  linkToBtnText,
  subtitle,
  children,
  disableBadges,
  background,
  setChallengeTitle,
  zone,
}) => {
  const navigate = useNavigate();

  const hasCreateChallenge = brand.hasCreate.challenges;

  const badges = hasCreateChallenge ? filterButtons : [];

  const isZone = zone && zone.title;

  return (
    <>
      <CoverImage
        src={background}
        alt={headline}
        heading={headline}
        desc={i18next.t(subtitle)}
      >
        {!isZone && (
          <Flex gap="2" align="center">
            {children}
            {!children &&
              selectedFilter &&
              setSelectedFilter &&
              badges &&
              badges.map((filter) => {
                return (
                  <Badge
                    size="2"
                    key={filter.value}
                    variant={filter.value === selectedFilter ? "solid" : "soft"}
                    onClick={() => {
                      if (!disableBadges) {
                        setSelectedFilter(filter.value);

                        if (setChallengeTitle) {
                          setChallengeTitle(filter.text);
                        }
                      }
                    }}
                  >
                    {i18next.t(filter.text)}
                  </Badge>
                );
              })}

            {!brand.event.isEvent && linkToBtnLink && hasCreateChallenge && (
              <Button
                variant="soft"
                size="1"
                onClick={() => navigate(linkToBtnLink)}
              >
                {i18next.t(linkToBtnText)}
              </Button>
            )}
          </Flex>
        )}
      </CoverImage>
    </>
  );
};

export default OverviewArchive;
